module.exports = __webpack_public_path__ + "55fad7f4c3461fa402f9de5a47758720.png";